module.exports = __webpack_public_path__ + "static/slowmist-8064d9c704b447f1f297620a911b0a67.svg";